const googleApiKey = 'AIzaSyDTy0Kal135PjUequTBGbC86qWNl9WNVCw';

export { googleApiKey };
